import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function MidCTA() {
  return <section className="py-12 px-4 bg-salvia-light/30" data-id="element-129">
      <div className="max-w-4xl mx-auto text-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-131">
          <Button href="https://yoga360.impultienda.ar/checkout" className="text-lg md:text-xl py-4 px-8 shadow-lg" data-id="element-132">
            👉 BASTA DE IMPROVISAR — QUIERO MI YOGA 360
          </Button>
        </motion.div>
      </div>
    </section>;
}